import * as userApi from '../common/api/user';
import { deleteFavorites, saveFavorites } from '../common/api/favorites';

export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const FETCH_USER_ENTITLEMENTS = 'FETCH_USER_ENTITLEMENTS';
export const FETCH_USER_ENTITLEMENTS_SUCCESS = 'FETCH_USER_ENTITLEMENTS_SUCCESS';
export const FETCH_USER_ENTITLEMENTS_FAILURE = 'FETCH_USER_ENTITLEMENTS_FAILURE';

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS';
export const FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS';
export const FETCH_USER_SETTINGS_FAILURE = 'FETCH_USER_SETTINGS_FAILURE';

export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';
export const UPDATE_USER_SETTINGS_FAILURE = 'UPDATE_USER_SETTINGS_FAILURE';

export const SKIP_USER_ONBOARDING = 'SKIP_USER_ONBOARDING';
export const SKIP_USER_ONBOARDING_SUCCESS = 'SKIP_USER_ONBOARDING_SUCCESS';
export const SKIP_USER_ONBOARDING_FAILURE = 'SKIP_USER_ONBOARDING_FAILURE';

export const FETCH_USER_FAVORITES = 'FETCH_USER_FAVORITES';
export const FETCH_USER_FAVORITES_SUCCESS = 'FETCH_USER_FAVORITES_SUCCESS';
export const FETCH_USER_FAVORITES_FAILURE = 'FETCH_USER_FAVORITES_FAILURE';

export const updateUserSettings = (updatedSetting) => async (dispatch) => {
  dispatch({ type: UPDATE_USER_SETTINGS });
  try {
    const settings = await userApi.updateUserSettings(updatedSetting);
    dispatch({
      type: UPDATE_USER_SETTINGS_SUCCESS,
      settings,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_USER_SETTINGS_FAILURE,
      error: err,
    });
  }
};

export const skipUserOnboarding = () => async (dispatch, getState) => {
  dispatch({ type: SKIP_USER_ONBOARDING });
  const {
    user: { settings },
  } = getState();

  const currentOnboarded = settings.onboarded || [];
  const onboarded = [...currentOnboarded, 'FAVORITE_SPOTS'];
  try {
    await userApi.updateUserSettings({
      onboarded,
    });
    dispatch({
      type: SKIP_USER_ONBOARDING_SUCCESS,
      onboarded,
    });
  } catch (err) {
    dispatch({
      type: SKIP_USER_ONBOARDING_FAILURE,
      error: err,
    });
  }
};

export const SET_FAVORITED_SPOT = 'SET_FAVORITED_SPOT';
export const SET_FAVORITED_SPOT_SUCCESS = 'SET_FAVORITED_SPOT_SUCCESS';
export const SET_FAVORITED_SPOT_FAILURE = 'SET_FAVORITED_SPOT_FAILURE';

export const toggleFavoriteSpot = (spot, isFavorite) => async (dispatch) => {
  dispatch({ type: SET_FAVORITED_SPOT });
  try {
    if (isFavorite) {
      await deleteFavorites([spot._id]);
    } else {
      await saveFavorites([spot._id]);
    }
    dispatch({
      type: SET_FAVORITED_SPOT_SUCCESS,
      spot,
      isFavorite: !isFavorite,
    });
  } catch (err) {
    dispatch({
      type: SET_FAVORITED_SPOT_FAILURE,
      error: err,
    });
  }
};
